
<mat-toolbar class="background-color-green" style=" position: sticky; top: 0;  z-index: 7;">
    
    <!-- <a [routerLink]="" (click)="backClicked()">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="arrow_back" style="padding-top:9px; margin-right:10px; color:white;"></mat-icon>
    </a> -->
    <a (click)="goBack()">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="arrow_back" style="padding-top:9px; margin-right:10px; color:white;"></mat-icon>
    </a>
    <span class="text-color-white">{{ 'ml_151122' | translate }}</span>
    <span class="text-color-white" style="margin-left: 6px;" *ngIf="browserLangToUse.includes('zh')"> ( {{ apexId }} )</span>
    <span class="example-spacer"></span>
    
    <a (click)="goBack()">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home" style="padding-top:9px;  color:white;"></mat-icon>
    </a>

    <!-- <a routerLink="/">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home" style="padding-top:9px;  color:white;"></mat-icon>
    </a> -->
    
</mat-toolbar>

<div *ngIf="isLoading" class="center">
    <mat-spinner class="example-margin" [color]="color"></mat-spinner>
</div>

<div *ngIf="!isLoading">
    <mat-list>
        
        <mat-card class="example-card" >
            <mat-card-header style="background-color: whitesmoke; margin-bottom: 16px;">
                
                
                <mat-card-title class="flex-basis-200px font-weight-600" style="font-size: 20px;">{{ currentteamMessage.title }}</mat-card-title>
                <mat-card-subtitle >
                    <span>{{ sender }} </span>
                    
                    <span>{{ createTime }}</span>
                </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                
                
                <div [innerHTML]="addNewLine(urlify(currentteamMessage.body))"></div>
            </mat-card-content>
            <mat-card-actions  align="end">
                <button mat-raised-button *ngIf="checkIfAttachmentExist()" style="background-color: #00BFFF; color: white;" (click)="openDialog(currentteamMessage)" class="text-color-blue">{{ 'ml_144011' | translate }}</button>
                <span class="example-spacer"></span>
                <button mat-raised-button style="color: white;" (click)="markRead()" class="text-color-blue" [style.background]="disableButton ? '' : '#00BFFF'" [disabled]="disableButton">{{ disableButton ? alreadyRead : markAsRead }}</button>                
            </mat-card-actions>
        </mat-card>
    </mat-list>
</div>